import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%', // need for viewport 100% bg
      width: '100%'
    },
    body: {
      width: '100%',
      minHeight: '100vh',
      fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    },
    'h1,h2,h3,h4,h5,h6': {
      color: (theme.palette.type === 'dark' ? '#fff' : '#545454'),
    },
    a: {
      textDecoration: 'none'
    },
    // '#root': {
    //   height: '100%',
    //   width: '100%'
    // },
    '#chartjs-tooltip': {
      zIndex: 1,
      opacity: 1,
      padding: 6,
      pointerEvents: 'none',
      position: 'absolute',
      // border: 'none',
      borderRadius: 6,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.background.default,
      fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      fontSize: 11,
      // transform: 'translate(-50%, 0)',
      transition: 'all 0.25s ease-in-out',
      boxShadow: theme.shadows[4],
      // '&.center:after': {
      //   bottom: '100%',
      //   left: '50%',
      //   border: 'solid #fff',
      //   content: '""',
      //   position: 'absolute',
      //   pointerEvents: 'none',
      //   borderColor: 'transparent',
      //   borderBottomColor: 'rgba(255, 255, 255, 0.95)',
      //   borderWidth: '5px',
      //   marginLeft: '-5px'
      // },
      // '&.left': {
      //   transform: 'translate(0, 0)',
      //   '&:after': {
      //     left: 10,
      //   }
      // },
      '&:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        margin: 'auto',
        width: 0,
        height: 0,
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: '6px',
      },
      '&.top.center:after': {
        borderBottomColor: theme.palette.background.default,
        top: '-11px',
        left: 0,
        right: 0
      },
      '&.top.left:after': {
        borderBottomColor: theme.palette.background.default,
        top: '-11px',
        left: '5px'
      },
      '&.top.right:after': {
        borderBottomColor: theme.palette.background.default,
        top: '-11px',
        right: '5px'
      },
      '&.bottom.center:after': {
        borderTopColor: theme.palette.background.default,
        bottom: '-11px',
        left: 0,
        right: 0
      },
      '&.bottom.left:after': {
        borderTopColor: theme.palette.background.default,
        bottom: '-11px',
      },
      '&.bottom.right:after': {
        borderTopColor: theme.palette.background.default,
        bottom: '-11px',
        right: '5px'
      },
      '&.center.left:after': {
        borderRightColor: theme.palette.background.default,
        margin: 'auto',
        left: '-11px',
        bottom: 0,
        top: 0
      },
      '&.center.right:after': {
        borderLeftColor: theme.palette.background.default,
        margin: 'auto',
        right: '-11px',
        bottom: 0,
        top: 0
      },
      '& p': {
        color: theme.palette.getContrastText(theme.palette.background.default),
        marginBottom: 5,
        lineHeight: 1.5
      },
      '& ul': {
        marginBottom: 8,
        '&.grid': {
          listStyle: 'none',
          whiteSpace: 'nowrap',
          display: 'grid',
          gridTemplateColumns: 'repeat(2, fit-content(50%))',
          gap: 8,
          [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
          }
        },
        '&.flex-column': {
          listStyle: 'none',
          whiteSpace: 'nowrap',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        },
      },
      '& li': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }
    },
    '.legend': {
      // marginTop: 8,
      // marginBottom: 24,
      margin: 4,
      display: 'flex',
      justifyContent: 'center',
      font: '12px ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      '& .flex': {
        display: 'flex',
        gap: 16,
        justifyContent: 'stretch',
        width: '100%'
      },
      '& .flex-column': {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
      },
      '& .legend-title': {
        fontSize: 11,
        marginBottom: 8,
        '& label': {
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          '& input[type=checkbox]': {
            display: 'inline-block',
            width: 14,
            height: 14,
            marginRight: 8,
            flexShrink: 0,
          },
          '& span': {
            lineHeight: 1.5
          }
        }
      },
      '& ul, & li': {
        color: theme.palette.text.secondary,
        listStyle: 'none',
        whiteSpace: 'nowrap',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '2px 0',
      },
      '& li': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        '& *': {
          cursor: 'pointer',
        },
        '&.disable-legend': {
          textDecoration: 'line-through'
        },
        '& input, & span': {
          display: 'inline-block',
          width: 14,
          height: 14,
          marginRight: 8,
          flexShrink: 0,
        },
        '& input.invisible': {
          display: 'none'
        },
        '& p': {
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          margin: '0 !important'
        }
      }
    },
    'svg .country': {
      stroke: theme.palette.action.hover,
      strokeWidth: 1,
      '&:hover': {
        stroke: theme.palette.action.active,
      }
    },
    '.tableChartContainer.print': {
      justifyContent: 'flex-start',
      '&> .MuiBox-root': {
        height: 'auto'
      }
    },
    // loader
    '.lds-facebook': {
      display: 'inline-block',
      position: 'relative',
      width: 100,
      height: 80
    },
    '.lds-facebook div': {
      display: 'inline-block',
      position: 'absolute',
      left: 8,
      width: 24,
      // background: '#66BB6A',
      animation: 'lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite'
    },
    '.lds-facebook div:nth-child(1)': {
      left: 8,
      background: '#66BB6A',
      animationDelay: '-0.24s'
    },
    '.lds-facebook div:nth-child(2)': {
      left: 40,
      background: '#388E3C',
      animationDelay: '-0.12s'
    },
    '.lds-facebook div:nth-child(3)': {
      left: 72,
      background: '#1B5E20',
      animationDelay: 0
    },
    '@keyframes lds-facebook': {
      '0%': {
        top: 8,
        height: 64
      },
      '50%, 100%': {
        top: 24,
        height: 28
      }
    },
    // sunburst
    '.sunburst-viz': {
      '& .text-contour': {
        strokeWidth: 0
      },
      '& .text-stroke': {
        fill: '#fff'
      }
    },
    '.sunburst-tooltip': {
      border: 'none',
      borderRadius: 6,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.background.default,
      fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      fontSize: 11,
      transform: 'translate(-50%, 0)',
      transition: 'all 0.25s ease-in-out',
      boxShadow: theme.shadows[4],
      whiteSpace: 'pre-line',
      '& .tooltip-title': {
        color: theme.palette.text.primary,
        fontWeight: 'bold'
      }
    },
    '.antd-tooltip': {
      padding: '6px 0',
      lineHeight: 1.5
    }
  }
}));

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
